// Turn negative zero into a positive zero.
export default function fixNegativeZero(number: number): number {
  const isNegativeZero = number === 0 && 1 / number < 0;

  if (isNegativeZero) {
    return number * -1;
  }

  return number;
}
